import { del, get, getBlob, patch, post, put } from '../client';

export const appUsersApi = {
  list: (params) => get('/app-users', { params }),
  exportExcel: (params) => getBlob('/app-users/export', { params }),
  getById: (id) => get(`/app-users/${id}`),
  updateKyc: (id, body) => patch(`/app-users/${id}/kyc`, body),
  assignBu: (id, body) => post(`/app-users/${id}/business-units`, body),
  syncBu: (id, body) => put(`/app-users/${id}/business-units`, body),
  revokeBu: (id, buId, siteId) =>
    siteId == null
      ? del(`/app-users/${id}/business-units/${buId}`)
      : del(`/app-users/${id}/business-units/${buId}/sites/${siteId}`),
  sendNotification: (id, body) => post(`/app-users/${id}/notifications`, body),
  aiVerify: (id) =>
    post(`/app-users/${id}/ai-verify`, {}, { timeout: 120000 }),
  lastAiVerify: (id) => get(`/app-users/${id}/ai-verify/last`),
  aiVerifyHistory: (id) => get(`/app-users/${id}/ai-verify/history`),
  gstLookup: (id, body = {}) =>
    post(`/app-users/${id}/gst-lookup`, body, { timeout: 60000 }),
};
